import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import * as moment from "moment";
import { Anchor, Image } from "hesus-ui-kit";
import { getDateFormat } from "@utils/datePickerUtils";
import {
  renderPriceWithCurrency,
  addSpace,
  getConvertedPrice,
} from "@utils/utils";
import {
  GridRow,
  GridSubItem,
  SolutionIdLink,
} from "../../GeneralPlanningList.styled";
import "../../GeneralPlanningList.scss";
import disputeExistIcon from "@icons/dispute-exist.svg";
import noDisputeIcon from "@icons/no-dispute.svg";
import greySummaryIcon from "@icons/supplier-sumarry-grey.svg";
import blueSummaryIcon from "@icons/supplier-sumarry-blue.svg";
import darkBlueSummaryIcon from "@icons/supplier-sumarry-blue-dark.svg";
import darkBlueInvoicedIcon from "@icons/ic-invoiced.svg";

const GlobalListing = ({
  t,
  planningData,
  onSolutionIdClick,
  onDisputeView,
  onDisputeAdd,
  summaryAction,
  summaryByService,
}) => {
  const getSummaryStatus = (status) => {
    let imageSrc = greySummaryIcon;
    if (status === 1) {
      imageSrc = blueSummaryIcon;
    }
    if (status === 2) {
      imageSrc = darkBlueSummaryIcon;
    }
    if (status === 3) {
      imageSrc = darkBlueInvoicedIcon;
    }
    return imageSrc;
  };

  const getSummaryTitle = (status) => {
    let summaryImageTitle = "SUMMARIES_ACTION_TOOLTIP_NO_SUMMARY";
    if (status === 1) {
      summaryImageTitle = "SUMMARIES_ACTION_TOOLTIP_EDIT_SUMMARY";
    }
    if (status === 2) {
      summaryImageTitle = "SUMMARIES_ACTION_TOOLTIP_EDIT_COMPLETED_SUMMARY";
    }
    if (status === 3) {
      summaryImageTitle = "SUMMARIES_ACTION_TOOLTIP_EDIT_INVOICED_SUMMARY";
    }
    return summaryImageTitle;
  };
  if (!planningData || !Array.isArray(planningData)) {
    return null; // or return a loading/empty state
  }

  return planningData.map((line, lineIndex) => (
    <React.Fragment key={`quote-item${line?.id}${lineIndex}`}>
      <GridRow
        key={`planning-orders-site${line.id}${lineIndex}`}
        column="6% 15% 20% 19% 19% 5% 5% 5% 6%"
        marginBottom="0px"
        gap="1px;"
        borderLeft="2px solid #767676"
        borderBottom="2px solid #767676"
        borderRight="2px solid #767676"
      >
        <GridSubItem
          color="#0A4986"
          fontStyle="normal"
          padding="5px 5px 0px 10px"
          fontWeight="700"
          text-align="center"
          vertical-align="middle"
          borderRight="2px solid rgb(118, 118, 118)"
        >
          {getDateFormat(line?.planningDate,"YYYY-MM-DD")}
        </GridSubItem>

        <GridRow borderRight="2px solid rgb(118, 118, 118)" gap="0rem">
          <GridSubItem
            color="#0A4986"
            padding="5px 5px 0px 10px"
            fontWeight="700"
            fontSize="16px"
            alignContent="none"
          >
            <Anchor
              className="planning-list__link"
              url={`/site/view/${line?.site?.id}/general-info`}
              target="_blank"
            >
              {` #${line?.site?.id}`}
            </Anchor>
            {` - ${line?.site?.name}`}
          </GridSubItem>
          <GridSubItem
            fontWeight="400"
            fontSize="16px"
            color="#474747"
            fontStyle="italic"
            padding="0px 5px 5px 10px"
            alignContent="none"
          >
            {line?.site?.company}
          </GridSubItem>
        </GridRow>

        <GridRow
          gap="0rem"
          borderRight="2px solid rgb(118, 118, 118)"
          column="1fr auto"
        >
          <GridRow gap="0rem">
            <GridSubItem
              fontWeight="700"
              fontSize="16px"
              padding="5px 5px 5px 10px"
            >
              {line?.clientOrder?.hesusService.name}
            </GridSubItem>
            <GridSubItem
              fontWeight="400"
              fontSize="16px"
              color="#474747"
              fontStyle="italic"
              padding="5px 5px 5px 10px"
              alignContent="none"
            >
              {line.clientOrder?.hesusService.needProduct &&
                line.clientOrder?.product.name}
              {line.clientOrder?.hesusService.needProduct &&
                line.clientOrder?.hesusService.needTransport &&
                " - "}
              {line.clientOrder?.hesusService.needTransport &&
                line.clientOrder?.transport.name}
            </GridSubItem>
          </GridRow>
          <GridSubItem
            fontWeight="700"
            fontSize="16px"
            textAlign="right"
            color="#474747"
          >
            {renderPriceWithCurrency(
              addSpace(
                getConvertedPrice(
                  line.clientOrder?.quoteServiceCurrency?.id,
                  line.clientOrder?.sellingPrice,
                  line.clientOrder?.exchangeRates
                )
              ),
              t(line.clientOrder?.unit),
              line.clientOrder?.quoteCurrency?.symbol,
              line.clientOrder?.quoteCurrency?.position
            )}
          </GridSubItem>
        </GridRow>

        <GridRow>
          {line?.hesusService.needCarrier &&
            (!line?.hesusService.needCombination ||
              (line?.hesusService.needCombination &&
                line?.hesusService.needCombinationCenter)) && (
              <GridRow column="1fr auto">
                <GridRow gap="0rem">
                  <GridSubItem
                    fontWeight="700"
                    fontSize="16px"
                    padding="0px 5px 0px 10px"
                  >
                    {line.haulage.company?.name}
                  </GridSubItem>
                  <GridSubItem
                    fontWeight="400"
                    fontSize="16px"
                    color="#474747"
                    fontStyle="italic"
                    padding="0px 5px 5px 10px"
                    alignContent="none"
                  >
                    {line.haulage.transport?.name}
                  </GridSubItem>
                </GridRow>
                <GridSubItem
                  fontWeight="700"
                  fontSize="16px"
                  textAlign="right"
                  color="#474747"
                >
                  {renderPriceWithCurrency(
                    addSpace(
                      getConvertedPrice(
                        line?.haulage?.currency?.id,
                        line?.haulage?.purchasePrice,
                        line?.clientOrder?.exchangeRates
                      )
                    ),
                    t(line?.haulage?.purchaseUnit),
                    line?.clientOrder?.quoteCurrency?.symbol,
                    line?.clientOrder?.quoteCurrency?.position
                  )}
                </GridSubItem>
              </GridRow>
            )}
        </GridRow>

        <GridRow borderLeft="2px solid rgb(118, 118, 118)">
          {line?.hesusService.needCenter &&
            (!line?.hesusService.needCombination ||
              (line?.hesusService.needCombination &&
                line?.hesusService.needCombinationCarrier)) && (
              <GridRow column="1fr auto">
                <GridRow gap="0rem">
                  <GridSubItem
                    fontWeight="700"
                    fontSize="16px"
                    padding="0px 5px 0px 10px"
                  >
                    <SolutionIdLink
                      onClick={() =>
                        onSolutionIdClick(line.solution.solutionId)
                      }
                    >
                      #{line.solution.solutionId}
                    </SolutionIdLink>{" "}
                    - [ {line.solution.centre?.supplierName}] -{" "}
                    {line.solution.centre?.name}
                  </GridSubItem>
                  <GridSubItem
                    fontWeight="400"
                    fontSize="16px"
                    color="#474747"
                    fontStyle="italic"
                    padding="0px 5px 5px 10px"
                    alignContent="none"
                  >
                    {line.solution.product?.name}
                  </GridSubItem>
                </GridRow>
                <GridSubItem
                  fontWeight="700"
                  fontSize="16px"
                  textAlign="right"
                  color="#474747"
                >
                  {renderPriceWithCurrency(
                    addSpace(
                      getConvertedPrice(
                        line?.solution?.currency?.id,
                        line?.solution?.purchasePrice,
                        line?.clientOrder.exchangeRates
                      )
                    ),
                    t(line?.solution?.purchaseUnit),
                    line?.clientOrder?.quoteCurrency?.symbol,
                    line?.clientOrder?.quoteCurrency?.position
                  )}
                </GridSubItem>
              </GridRow>
            )}
        </GridRow>

        <GridSubItem
          fontWeight="700"
          fontStyle="normal"
          fontSize="16px"
          textAlign="center"
          color="#0A4986"
          borderLeft="2px solid #767676"
        >
          {`${line.quantity} ${t(line.unit)}`}
        </GridSubItem>

        <GridSubItem
          fontWeight="700"
          fontStyle="normal"
          fontSize="16px"
          textAlign="right"
          color="#0A4986"
          borderLeft="2px solid #767676"
        >
          {getConvertedPrice(
            line?.solution?.currency?.id,
            line?.turnover,
            line?.clientOrder?.exchangeRates
          )
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            .padEnd(10, " ")}{" "}
          {line.clientOrder.quoteCurrency.symbol}
        </GridSubItem>

        <GridSubItem
          fontWeight="700"
          fontSize="16px"
          textAlign="center"
          padding="5px 5px 0px 10px"
          borderLeft="2px solid #767676"
          color={
            // eslint-disable-next-line no-nested-ternary
            line.marginRate >= 12
              ? "#0A4986"
              : line.marginRate <= 6
              ? "#E83F1E"
              : "#F08046"
          }
        >
          {parseFloat(line.marginRate).toFixed(2)}%
        </GridSubItem>

        <GridSubItem
          fontWeight="700"
          fontSize="16px"
          textAlign="center"
          padding="5px 5px 0px 10px"
          borderLeft="2px solid #767676"
          color={
            // eslint-disable-next-line no-nested-ternary
            line.marginRate >= 12
              ? "#0A4986"
              : line.marginRate <= 6
              ? "#E83F1E"
              : "#F08046"
          }
        >
          {parseInt(line?.disputeCount, 10) > 0 && (
            <Image
              src={disputeExistIcon}
              className="planning-list__general-planning-site-image-icon"
              onClick={() => onDisputeView(line?.lineGroupId, line?.site?.id)}
              alt={t("SUPPLIERS_PLANNING_VIEW_DISPUTES")}
              title={t("SUPPLIERS_PLANNING_VIEW_DISPUTES")}
            />
          )}
          {parseInt(line?.disputeCount, 10) === 0 && (
            <Image
              src={noDisputeIcon}
              className="planning-list__general-planning-site-image-icon"
              onClick={() => onDisputeAdd(line?.lineGroupId, line?.site?.id)}
              alt={t("SUPPLIERS_PLANNING_ADD_DISPUTE")}
              title={t("SUPPLIERS_PLANNING_ADD_DISPUTE")}
            />
          )}
          {line?.hesusService?.needSupplierPlanning && (
            <Image
              src={getSummaryStatus(line.summaryStatus)}
              className="planning-list__general-planning-site-image-icon"
              onClick={() =>
                summaryByService(
                  line.summaryStatus,
                  "",
                  line?.clientOrderItemId,
                  line?.site?.id,
                  line?.lineGroupId,
                  line?.hesusService,
                  line?.haulage?.companyInfo,
                  line?.solution?.centreInfo
                )
              }
              alt={t(getSummaryTitle(line.summaryStatus))}
              title={t(getSummaryTitle(line.summaryStatus))}
            />
          )}
          {!line?.hesusService?.needSupplierPlanning && (
            <Image
              src={getSummaryStatus(line.summaryStatus)}
              className="planning-list__general-planning-site-image-icon"
              onClick={() =>
                summaryAction(
                  line.summaryStatus,
                  "",
                  line?.clientOrderItemId,
                  line?.site?.id
                )
              }
              alt={t(getSummaryTitle(line.summaryStatus))}
              title={t(getSummaryTitle(line.summaryStatus))}
            />
          )}
        </GridSubItem>
      </GridRow>
    </React.Fragment>
  ));
};

GlobalListing.propTypes = {
  t: PropTypes.func.isRequired,
  planningData: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSolutionIdClick: PropTypes.func.isRequired,
  onDisputeView: PropTypes.func.isRequired,
  onDisputeAdd: PropTypes.func.isRequired,
  summaryAction: PropTypes.func.isRequired,
  summaryByService: PropTypes.func.isRequired,
};

GlobalListing.defaultProps = {};

export default withTranslation()(GlobalListing);
